import React from "react"
import "../index.less"
import emptyResult from "images/empty-result-dashboard.svg"
import { loadTexts } from "../../../utils/i18n"

const ResultEmptyState = (props) => {
  const intl = loadTexts("reports_dashboard")
  return (
    <>
      <img
        src={emptyResult}
        alt="empty result"
        className="report-card-body-empty-result"
      />
      <div className="report-card-body-description">
        {intl.dashboard.reportCard.resultEmptyState}
      </div>
    </>
  )
}

export default ResultEmptyState
